export default {
  form: {
    address: {
      label: 'Adres',
      placeholder: 'Straat + huisnummer',
    },
    city: {
      label: 'Stad',
      placeholder: 'Stad',
    },
    state: {
      label: 'Provincie',
      placeholder: 'Selecteer provincie',
    },
    country: {
      label: 'Land',
      placeholder: 'Selecteer land',
    },
    zip_code: {
      label: 'Postcode',
      placeholder: 'Postcode',
    },
  },
};
